export class GlobalVariables {
  public static readonly DATE_TIME_FORMAT: string = 'DD/MM/YYYY HH:mm:ss';
  public static readonly DATE_FORMAT: string = 'DD/MM/YYYY';
  public static readonly DATE_PICKER_FORMAT: string = 'YYYY-MM-DD';
  public static readonly SHORT_TIME_FORMAT: string = 'HH:mm';
  public static readonly ION_DATE_TIME_FORMAT: string = 'yyyy-MM-ddTHH:mm';
  public static readonly PAGE_SIZE: number = 10;
  public static readonly IDLE_TIME: number = 10 * 60 * 1000; // 25 * 60 * 1000;
  public static readonly PUBLIC_MANAGER_INDEX_NUM: number = 1;
}
